import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

import type { PusherError } from '@/types/events'

declare global {
  interface Window {
    Echo?: Echo<any>
    __ECHO_ERR__?: unknown
    __ECHO_INITIALIZED__?: boolean
  }
}

;(window as any).Pusher = Pusher

function env(name: string): string | undefined {
  return (import.meta as any).env?.[name]
}

function isLocalHost(host: string): boolean {
  return host === 'localhost' || host === '127.0.0.1' || host.endsWith('.test') || host.endsWith('.local')
}

function initEcho() {
  if (window.__ECHO_INITIALIZED__ || window.Echo) return

  window.__ECHO_INITIALIZED__ = true

  try {
    const isHttps = window.location.protocol === 'https:'
    const host = window.location.hostname
    const local = isLocalHost(host)

    const key = env('VITE_REVERB_APP_KEY') || env('VITE_PUSHER_APP_KEY') || 'local'

    const pagePort = Number(window.location.port) || (isHttps ? 443 : 80)

    const wsPort = Number(env('VITE_REVERB_WS_PORT') || '') || (local ? pagePort : 80)
    const wssPort = Number(env('VITE_REVERB_WSS_PORT') || '') || (local ? pagePort : 443)

    window.Echo = new Echo({
      broadcaster: 'pusher',
      key,
      cluster: 'mt1',

      wsHost: host,
      wsPort,
      wssPort,
      wsPath: '',
      forceTLS: isHttps,
      encrypted: isHttps,

      enabledTransports: ['ws', 'wss'],

      disableStats: true,
      authEndpoint: '/broadcasting/auth',
      withCredentials: true
    })
  } catch (e) {
    window.__ECHO_INITIALIZED__ = false
    window.__ECHO_ERR__ = e as PusherError
    console.error('[echo.ts] init failed — continuing without realtime:', e)
  }
}

if (document.readyState === 'complete') {
  initEcho()
} else {
  window.addEventListener('load', initEcho, { once: true })
}
